"use client";
import React from "react";
import OverlayWrapper from "@/components/ui/OverLayWrapper";
import ForgotPasswordStepper from "./ForgotPasswordStepper";
import LangButton from "@/components/ui/LangButton";
import Image from "next/image";
import arrow2 from "@/../public/assets/images/arrow2.svg";
import { useLocaleState } from "@/hooks/useLocaleState";
import { X } from "lucide-react";

const headerTranslations = {
  en: {
    title: "Reset password",
    subtitle: "Follow the steps to change your password",
  },
  fa: {
    title: "بازیابی رمز عبور",
    subtitle: "برای تغییر رمز عبور مراحل را دنبال کنید",
  },
};

export default function ForgotPasswordOverlay({
  onClose,
  onPrefillEmail,
  defaultEmail,
}: {
  onClose: () => void;
  onPrefillEmail?: (email: string) => void;
  defaultEmail?: string;
}) {
  const { changeLocale, currentLang, setCurrentLang } = useLocaleState();
  const t = headerTranslations[currentLang];
  const dir = currentLang === "fa" ? "rtl" : "ltr";
  return (
    <OverlayWrapper
      onClose={onClose}
      snapPoints={["93vh"]}
      draggable={false}
    >
      <div className="flex h-full items-start justify-center px-2 bg-grayCustom">
        <div className="max-w-md w-full rounded p-6 ">
          <div className="flex justify-between mb-10">
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-slateCustom transition hover:text-pinkCustom"
            >
              <X className="h-4 w-4" strokeWidth={4} />
            </button>
            <LangButton
              currentLang={currentLang}
              setCurrentLang={setCurrentLang}
              bgColor="white"
              onLocaleChange={changeLocale}
            />
          </div>
          <h1
            dir={dir}
            className="relative text-xl font-semibold leading-tight mt-0 mb-8"
          >
            {t.title}
            <div
              className={`absolute ${
                currentLang === "fa" ? "-right-[14px]" : "-left-[14px]"
              } bottom-[26px]`}
            >
              <Image
                className="w-[12px]"
                src={arrow2}
                alt="arrow"
                style={{
                  transform: currentLang === "fa" ? "scaleX(-1)" : "none",
                }}
              />
            </div>
            <p className="text-xs font-light text-gray-400 mt-2">
              {t.subtitle}
            </p>
          </h1>
          <ForgotPasswordStepper
            onClose={onClose}
            onPrefillEmail={onPrefillEmail}
            defaultEmail={defaultEmail}
            currentLang={currentLang}
          />
        </div>
      </div>
    </OverlayWrapper>
  );
}
